import { render, staticRenderFns } from "./PageBlogList.vue?vue&type=template&id=fe1296b0&scoped=true&"
import script from "./PageBlogList.vue?vue&type=script&lang=js&"
export * from "./PageBlogList.vue?vue&type=script&lang=js&"
import style0 from "./PageBlogList.vue?vue&type=style&index=0&id=fe1296b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1296b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ohid/instaprivat/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe1296b0')) {
      api.createRecord('fe1296b0', component.options)
    } else {
      api.reload('fe1296b0', component.options)
    }
    module.hot.accept("./PageBlogList.vue?vue&type=template&id=fe1296b0&scoped=true&", function () {
      api.rerender('fe1296b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/blog/PageBlogList.vue"
export default component.exports